export enum NotificationDefinitionStatus {
    Active = 'active',
    Inactive = 'inactive',
}
